import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

export interface PracticeLocationOption {
  id: string;
  libelle: string;
  disabled?: boolean;
}

/**
 * Sélection du lieu d'exercice, partagée entre la modal CPX (stratégie websocket)
 * et la modal Pro Santé Connect (stratégie REST) afin que leur rendu reste identique.
 */
@Component({
  selector: 'app-select-practice-location',
  templateUrl: './select-practice-location.component.html',
  styleUrls: ['./select-practice-location.component.scss']
})
export class SelectPracticeLocationComponent implements OnInit {

  @Input() public practiceLocations: Array<PracticeLocationOption> = [];
  @Input() public showUnautorizedMessage = false;
  @Output() public selectLocation = new EventEmitter<string>();
  @Output() public cancelSelection = new EventEmitter<void>();

  public formGroup: FormGroup;

  constructor(
    private _formBuilder: FormBuilder
  ) { }

  ngOnInit(): void {
    this.formGroup = this._formBuilder.group({
      location: [this.practiceLocations?.find(pl => !pl.disabled)?.id, [Validators.required]]
    });
  }

  public validate(): void {
    if (this.formGroup.valid) {
      this.selectLocation.emit(this.formGroup.get('location').value);
    }
  }
}
